module.exports = __webpack_public_path__ + "img/opciones.7bb6a929.svg";